import { APP_MAX_WIDTH_PX } from '../../constants'
import styled, { keyframes } from 'styled-components';

export const moveChevron = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
`;

export const StyledChevronWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  object-fit: cover;
  preserveAspectRatio: none;
}
`

export const StyledLoadingContainer = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  max-width: ${APP_MAX_WIDTH_PX}px;
  margin: 0 auto;
  display: flex;
  overflow: hidden;
  transition: opacity 2s ease-in-out;
`


export const StyledChevron = styled.svg`
  height: 100vh;
  animation: ${moveChevron} 1s linear infinite;
`

export const StyledTitleContainer = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  color: white;
`